import React from "react";
import { motion } from "framer-motion";
import { CalendarDays } from "lucide-react";
import LanguageSupportNotice from "../Components/LanguageSupportNotice";
import { fastSeasons, feastDays } from "../siteData";

export default function EOTCCalendar() {
  return (
    <div className="font-sans-clean min-h-screen bg-[#FDF8F3]">
      <section className="relative py-20 sm:py-24 overflow-hidden bg-[#5b2229]">
        <div className="absolute inset-0 opacity-20 ethiopian-cross" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl"
          >
            <h1 className="font-serif-elegant text-4xl sm:text-5xl font-bold text-white mb-4">
              EOTC Calendar
            </h1>
            <p className="text-white/80 text-lg">
              Major feast days and fast seasons, presented as a readable parish reference.
            </p>
          </motion.div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <LanguageSupportNotice />

        <h2 className="font-serif-elegant text-2xl font-bold text-[#722F37] mb-6">
          Major Feasts
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {feastDays.map((feast) => (
            <motion.div
              key={feast.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl shadow-sm border border-[#C9A227]/10 p-6 flex flex-col gap-3"
            >
              <div className="flex items-center gap-3">
                <CalendarDays className="w-6 h-6 text-[#C9A227]" />
                <span className="text-sm text-gray-500">{feast.dateLabel}</span>
              </div>

              <h3 className="font-serif-elegant text-xl font-bold text-[#722F37]">
                {feast.title}
              </h3>

              <p className="text-sm text-gray-600">{feast.description}</p>
            </motion.div>
          ))}
        </div>

        <h2 className="font-serif-elegant text-2xl font-bold text-[#722F37] mt-12 mb-6">
          Major Fast Seasons
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {fastSeasons.map((fast) => (
            <motion.div
              key={fast.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl shadow-sm border border-[#C9A227]/10 p-6 flex flex-col gap-3"
            >
              <div className="flex items-center gap-3">
                <CalendarDays className="w-6 h-6 text-[#C9A227]" />
                <span className="text-sm text-gray-500">{fast.dateLabel}</span>
              </div>

              <h3 className="font-serif-elegant text-xl font-bold text-[#722F37]">
                {fast.title}
              </h3>

              <p className="text-sm text-gray-600">{fast.description}</p>
            </motion.div>
          ))}
        </div>

        <p className="text-sm text-gray-500 mt-8 text-center">
          Movable feast and fasting dates vary year by year according to the Ethiopian Orthodox calendar.
          Confirm exact local observance dates through the parish schedule.
        </p>
      </div>
    </div>
  );
}
